// Single source of truth for playground sub-tools metadata.
// Consumed by PlaygroundLayout (nav rendering) and router.js (route registration).
// Lazy `component` loaders live in the DEV-gated branch of router.js so the
// chunks aren't emitted in prod builds.

// Keep the metadata out of production bundles as well as the route components.
// CommandPalette imports this module in every build, so the compile-time guard
// matters even though it only renders playground entries when the routes exist.
export const PLAYGROUND_TOOLS = import.meta.env.DEV
    ? [
          {
              name: "PlaygroundCheckFormRenderers",
              path: "check-form-renderers",
              label: "Check Form Renderers",
              icon: "vials",
              width: "full",
              description: "Review every check field in populated, empty, and full-form states."
          },
          {
              name: "PlaygroundRetailPlanner",
              path: "retail-planner",
              label: "Retail Planner",
              icon: "th",
              width: "full",
              description: "Prototype a retail floor and assess customer-flow constraints."
          },
          {
              name: "PlaygroundQrMenuPosters",
              path: "qr-menu-posters",
              label: "QR Menu Posters",
              icon: "qrcode",
              width: "full",
              description: "Compare branded menu posters and export a selected A4 design."
          },
          {
              name: "PlaygroundStorageDemo",
              path: "storage",
              label: "Google Storage",
              icon: "cloud-upload",
              width: "wide",
              description: "Inspect, preview, upload, and remove development storage objects."
          },
          {
              name: "PlaygroundCheckFormAssign",
              path: "checkform-assign",
              label: "Assign check forms",
              icon: "clipboard-check",
              width: "wide",
              description: "Control which check-form revisions staff can use."
          }
      ]
    : [];
